var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFantasialand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 38,
    viewBox: "0 0 259 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.377 13.7824H237.932V27.6617H251.377L256.148 23.3244V18.9871L251.377 13.7824Z",
    fill: "#CF1463"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6344 29.8303L26.7066 16.8185L27.574 13.7824L34.5137 29.8303H20.6344Z",
    fill: "#CF1463"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8865 29.8303L83.9587 16.8185L84.8261 13.7824L91.7657 29.8303H77.8865Z",
    fill: "#CF1463"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8865 29.8303L83.9587 16.8185L84.8261 13.7824L91.7657 29.8303H77.8865Z",
    fill: "#CF1463"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0177 22.0232H9.28298V18.1197H20.0177V22.0232ZM20.0177 10.3126V14.2161H4.40355V29.8303H0.5V10.3126H20.0177Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4865 29.8303L27.2454 9.33667L37.0043 29.8303H32.6128L27.2454 18.6076L21.878 29.8303H17.4865Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0667 16.1679V37.6374H38.1631V10.3126H42.0667L53.7773 23.975V0.553696H57.6809V29.8303H53.7773L42.0667 16.1679Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5567 14.2161V37.6374H67.6532V14.2161H59.8461V10.3126H79.3638V14.2161H71.5567Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3624 29.8303L84.1213 9.33667L93.8801 29.8303H89.4887L84.1213 18.6076L78.7539 29.8303H74.3624Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.277 29.8303H94.856V25.9267H118.277C118.826 25.9267 119.284 25.7438 119.65 25.3778C120.036 24.9915 120.229 24.5239 120.229 23.975C120.229 23.426 120.036 22.9686 119.65 22.6026C119.284 22.2163 118.826 22.0232 118.277 22.0232H110.47C108.844 22.0232 107.461 21.4539 106.323 20.3154C105.184 19.1769 104.615 17.7944 104.615 16.1679C104.615 14.5414 105.184 13.1589 106.323 12.0204C107.461 10.8818 108.844 10.3126 110.47 10.3126H122.181V14.2161H110.47C109.921 14.2161 109.454 14.4093 109.067 14.7955C108.701 15.1615 108.518 15.6189 108.518 16.1679C108.518 16.7168 108.701 17.1844 109.067 17.5707C109.454 17.9367 109.921 18.1197 110.47 18.1197H118.277C119.904 18.1197 121.286 18.6889 122.425 19.8275C123.563 20.966 124.133 22.3485 124.133 23.975C124.133 25.6014 123.563 26.984 122.425 28.1225C121.286 29.261 119.904 29.8303 118.277 29.8303Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.049 29.8303H126.145V10.3126H130.049V29.8303Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M131.025 29.8303L140.784 9.33667L150.543 29.8303H146.151L140.784 18.6076L135.416 29.8303H131.025Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M173.964 25.9267H189.578V29.8303H170.06V10.3126H173.964V25.9267Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M190.554 29.8303L200.313 9.33667L210.072 29.8303H205.68L200.313 18.6076L194.945 29.8303H190.554Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M215.134 16.1679V37.6374H211.23V10.3126H215.134L226.845 23.975V0.553696H230.748V29.8303H226.845L215.134 16.1679Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M248.741 29.8303H235.079V10.3126H248.741C251.445 10.3126 253.743 11.2681 255.633 13.1792C257.544 15.07 258.5 17.3674 258.5 20.0714C258.5 22.7754 257.544 25.083 255.633 26.9941C253.743 28.8849 251.445 29.8303 248.741 29.8303ZM238.982 25.9267H248.741C250.368 25.9267 251.75 25.3575 252.889 24.2189C254.027 23.0804 254.596 21.6979 254.596 20.0714C254.596 18.4449 254.027 17.0624 252.889 15.9239C251.75 14.7854 250.368 14.2161 248.741 14.2161H238.982V25.9267Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantasialand);
export default __webpack_public_path__ + "static/media/fantasialand.65fe44e7a4f0001d5293cfa7a16c7ecb.svg";
export { ForwardRef as ReactComponent };